export default "__VITE_ASSET__CQ_X_JwC__"